import styled from "styled-components";

const StyledAboutGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  justify-items: center;
  align-items: center;
  grid-template-areas:"about-img-selfportrait about-letter";

  .about_img-selfportrait {
    padding-right: 1rem;
    padding-left: 1rem;
  }

  .about_letter {
    padding: 4rem;
    font-family: Lato, sans-serif;
    //font-size: 1.5rem;
    font-size: calc(1rem + .25vw);
    font-style: italic;
    font-weight: 400;
    line-height: 1.2;
    text-align: left;
  }

  .about_paragraph {
    margin-bottom: 1rem;
  }

  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
    grid-template-areas:"about-img-selfportrait"      
                        "about-letter";
    grid-auto-columns: auto;
 
    .about_letter {
      padding: 2rem 1rem;
    }
  }

`

export default StyledAboutGrid